import { SystemUserProfile, SystemUserProfileResponse } from '../models/system-user.interface';

export const toSystemUserProfile = (r: SystemUserProfileResponse): SystemUserProfile => ({
  id: r.id ?? '',
  userId: r.userId ?? '',
  firstName: r.firstName ?? '',
  lastName: r.lastName ?? '',
  middleName: r.middleName ?? '',
  fullName: r.fullName ?? '',
  email: r.email ?? '',
  phoneNumber: r.phoneNumber ?? '',
  phoneCode: r.phoneCode ?? '',
  gender: r.gender ?? '',
  birthDate: r.birthDate ?? '',
});
